import React, { useEffect } from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop.jsx';
import HomePage from './pages/HomePage.jsx';
import AboutPage from './pages/AboutPage.jsx';
import PracticalInfoPage from './pages/PracticalInfoPage.jsx';
import PartnersPage from './pages/PartnersPage.jsx';
import JoinUsPage from './pages/JoinUsPage.jsx';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage.jsx';
import CookiePolicyPage from './pages/CookiePolicyPage.jsx';
import CookieConsentBanner from './components/CookieConsentBanner.jsx';
import { Toaster } from '@/components/ui/sonner';

// Le blog est hébergé sur Overblog : /blog redirige vers le site externe.
function BlogRedirect() {
  useEffect(() => {
    window.location.replace('https://neuviemecontinent.overblog.fr/');
  }, []);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/practical-info" element={<PracticalInfoPage />} />
        <Route path="/partners" element={<PartnersPage />} />
        <Route path="/join" element={<JoinUsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/cookie-policy" element={<CookiePolicyPage />} />
        <Route path="/blog" element={<BlogRedirect />} />
        <Route path="*" element={<HomePage />} />
      </Routes>
      <CookieConsentBanner />
      <Toaster />
    </Router>
  );
}

export default App;
